import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "./utiles/ApiConfig";

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchField, setSearchField] = useState("name");
  const [showOnlyActive, setShowOnlyActive] = useState(false);

  



  
  useEffect(() => {
    fetch(`${API_URL}/api/auth/get-all-users-data`)
      .then((res) => res.json())
      .then((data) => {
        if (data.user) {
          // Assuming 'createdAt' is the field you want to sort by
          const sortedUsers = data.user.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setUsers(sortedUsers);
        }
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);
  
  console.log("these are users", users);
  const filteredUsers = users.filter((user) => {
    let fieldValue = "";
  
    switch (searchField) {
      case "email":
        fieldValue = user.email;
        break;
      case "phone":
        fieldValue = user.phoneNumber || "";
        break;
      case "membership":
        fieldValue = user.memberships.length > 0 ? 
          user.memberships[user.memberships.length - 1].subscription_id.subscription_name : "";
        break;
      default: // "name"
        fieldValue = user.username;
    }
  
    const matchesSearch = fieldValue.toLowerCase().includes(search.toLowerCase());
  
    const isActive = showOnlyActive ? user.activeMembership : true;
  
    if (!startDate || !endDate) return matchesSearch && isActive;
  
    if (user.memberships.length > 0 && user.memberships[0].expiryDate) {
      const expiryDate = new Date(user.memberships[0].expiryDate);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return matchesSearch && expiryDate >= start && expiryDate <= end && isActive;
    }
  
    return false;
  });
  

  return (
    <div className="p-3 w-full">
      <div className="w-full mx-auto rounded-lg p-2 mt-2">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">User Management</h2>
        <div className="flex flex-col md:flex-row md:items-center md:gap-4 gap-2 mb-4">
  <select
    value={searchField}
    onChange={(e) => setSearchField(e.target.value)}
    className="p-2 border border-gray-300 text-sm md:text-normal rounded-md"
  >
    <option value="name">Name</option>
    <option value="email">Email</option>
    <option value="phone">Phone Number</option>
    <option value="membership">Membership Name</option>
  </select>

  <input
    type="text"
    placeholder={`Search by ${searchField}`}
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="flex-1 p-2 border border-gray-300 text-sm md:text-normal rounded-md"
  />

<div className="flex items-center gap-2">
  <label htmlFor="toggle-active" className="text-sm font-medium text-gray-700">
    {showOnlyActive ? "Showing: Active Users" : "Showing: All Users"}
  </label>
  <button
    id="toggle-active"
    onClick={() => setShowOnlyActive((prev) => !prev)}
    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 focus:outline-none ${
      showOnlyActive ? "bg-green-500" : "bg-gray-300"
    }`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
        showOnlyActive ? "translate-x-6" : "translate-x-1"
      }`}
    />
  </button>
</div>


<button
  onClick={() => {
    setSearch("");
    setSearchField("name");
    setShowOnlyActive(false);
    setStartDate("");
    setEndDate("");
  }}
  className="px-4 py-2 rounded-md bg-red-600 text-white text-sm md:text-normal font-semibold hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
>
  Clear Filters
</button>

</div>

        <div className="flex gap-4 mb-4">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="p-2 border border-gray-300 text-sm md:text-normal rounded-md"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="p-2 border border-gray-300 text-sm md:text-normal rounded-md"
          />
        </div>
        <div className="max-h-[70vh] overflow-y-scroll md:flex hidden">
          <table className="w-full border-collapse bg-white shadow-md rounded-md">
            <thead>
              <tr className="bg-blue-500 text-white sticky top-0">
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Email</th>
                <th className="p-3 text-left">Phone Number</th>
         
                <th className="p-3 text-left">Membership Name</th>
                <th className="p-3 text-left">Expiry Date</th>
                <th className="p-3 text-left">Active Membership</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr key={user._id} className="border-b hover:bg-gray-100">
                    <td className="p-3">
                      <Link to={`/admin/ManageUsers/user/${user._id}`} className="text-blue-500 hover:underline">
                        {user.username}
                      </Link>
                    </td>
                    <td className="p-3">{user.email}</td>
                    <td className="p-3">{user.phoneNumber || "N/A"}</td>
                
                    <td className="p-3">
                    {user.memberships && user.memberships.length > 0 ? 
  user.memberships[user.memberships.length - 1].subscription_id.subscription_name : 'No Membership'}




                    </td>

                    <td className="p-3">
                      {user.memberships.length > 0 && user.memberships[0].expiryDate
                        ? new Date(user.memberships[0].expiryDate).toLocaleDateString()
                        : ""}
                    </td>
                    <td className="p-3">
                      <span
                        className={`px-3 py-1 rounded-full text-white ${
                          user.activeMembership ? "bg-green-500" : "bg-red-500"
                        }`}
                      >
                        {user.activeMembership ? "Active" : "Not Active"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="p-3 text-center text-gray-500">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="md:hidden inline">
        <div className="space-y-2 max-h-[70vh] overflow-y-scroll">
          {filteredUsers.length > 0 ? (
          
            <>
            
            {filteredUsers.map((user) => (
  <div key={user._id} className="border rounded p-2 h-24 flex justify-between">
    <div className="flex flex-col justify-between w-24">
      <p className="p-2 rounded min-w-10 bg-gray-100">
        <Link to={`/ManageUsers/user/${user._id}`} className="text-blue-600">
          {user.username.length > 10 ? user.username.slice(0, 7) + "..." : user.username}
        </Link>
      </p>
      <span className="text-sm text-gray-600">
        {user.email.length > 10 ? user.email.slice(0, 23) + "..." : user.email}
      </span>
    </div>
    <div className="flex flex-col justify-between">
    
      <h1 className="text-sm text-gray-600 text-end">
        {user.memberships.length > 0 && user.memberships[0].expiryDate
          ? new Date(user.memberships[0].expiryDate).toLocaleDateString()
          : "N/A"}
      </h1>
      <p className="text-sm text-gray-600 text-end">
      {user.memberships && user.memberships.length > 0 ? 
  user.memberships[user.memberships.length - 1].subscription_id.subscription_name : 'No Membership'}
      </p>
      <span
        className={`px-2 py-1 text-sm rounded-full text-white ${
          user.activeMembership ? "bg-green-500" : "bg-red-500"
        }`}
      >
        {user.activeMembership ? "Active" : "Not Active"}
      </span>
    </div>
  </div>
))}

            </>
          ) : (
            <div>
              <p>No user Found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageUsers;
